import { base } from './base';

export const featureConfigMap = {
    base,
};
